var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('div',{staticClass:"coaching-inner-wrapper"},[_c('div',{staticClass:"content"},[_c('span',{staticClass:"byline"},[_vm._v(_vm._s(_vm.content.byline))]),_c('h2',[_vm._v(_vm._s(_vm.content.heading))]),_c('span',{staticClass:"purple-loader"})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }